<template>
  <div class="container">
    <listFilter
      :formItems="formItems"
      :filter="filter"
      @searchTableInfo="searchTableInfo"
      @resetTableInfo="resetTableInfo"
    ></listFilter>
    <div class="tableWrap">
      <div class="leftButton">
        <CustomButton
          type="primary"
          @click="showCreateAppli"
          :permissionCode="authType.app.createRowAuth"
          >新建应用</CustomButton
        >
        <CustomButton
          type="warning"
          @click="expertFileBtnClick"
          :permissionCode="authType.app.exportTableAuth"
          >导出</CustomButton
        >
      </div>
      <div class="tableBox">
        <Table
          border
          :columns="columns"
          size="small"
          stripe
          :data="dataSource"
          disabled-hover
          row-key="id"
          ref="tableRef"
        ></Table>
        <div style="margin: 10px; overflow: hidden">
          <div style="float: right">
            <Page
              show-total
              show-sizer
              :total="totalCount"
              :current="filter.pageIndex"
              :page-size="filter.pageSize"
              :page-size-opts="[10, 25, 50, 100]"
              @on-change="changePage"
              @on-page-size-change="pageSizeChange"
            ></Page>
          </div>
        </div>
      </div>
    </div>
    <!-- 蒙版弹出层 -->
    <Modal
      v-model="createAppModelStatus"
      :title="modalTitle"
      @on-ok="modalOKButtonClick('formValidate')"
      :loading="modalLoading"
      class="createModalClass"
    >
      <Form
        label-position="left"
        :label-width="80"
        :model="formValidate"
        ref="formValidate"
        :rules="ruleValidate"
      >
        <FormItem label="应用名称:" prop="appName">
          <Input
            placeholder="请输入应用名称"
            v-model="formValidate.appName"
          ></Input>
        </FormItem>
        <FormItem label="超时时长:" prop="loginTimeoutSec">
          <Input
            placeholder="请输入超时时长"
            v-model="formValidate.loginTimeoutSec"
          ></Input>
        </FormItem>
        <FormItem label="排序:" prop="appSortNum">
          <Input
            placeholder="请输入排序"
            v-model="formValidate.appSortNum"
          ></Input>
        </FormItem>
        <FormItem label="应用地址:" prop="appUrl">
          <Input
            placeholder="请输入应用地址"
            v-model="formValidate.appUrl"
          ></Input>
        </FormItem>
        <FormItem label="app登录回调地址:" prop="appLoginCallbackUrl">
          <Input
            placeholder="请输入app登录回调地址"
            v-model="formValidate.appLoginCallbackUrl"
          ></Input>
        </FormItem>
        <FormItem label=" 微服务：" prop="microServiceName">
          <Input
            v-model="formValidate.microServiceName"
            placeholder="请输入微服务"
          ></Input>
        </FormItem>
        <FormItem label="通讯录:" prop="addresss">
          <Select v-model="formValidate.address">
            <Option
              v-for="item in sysList"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="状态：" prop="appStatus">
          <Select v-model="formValidate.appStatus">
            <Option
              v-for="item in appStatusList"
              :label="item.label"
              :value="item.value"
              :key="item.value"
              >{{ item.label }}</Option
            >
          </Select>
        </FormItem>
        <FormItem label="应用描述:" prop="remark">
          <Input
            v-model="formValidate.remark"
            placeholder="请输入应用描述,最多200字"
            type="textarea"
            maxlength="200"
            show-word-limit
          ></Input>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formValidate')"
            >确认</Button
          >
          <Button @click="popCreateMoal" style="margin-left: 8px">取消</Button>
        </FormItem>
      </Form>
      <template #footer>
        <div style="height: 0px;"></div>
      </template>
    </Modal>
  </div>
</template>
<script>
import { CustomButton } from '../../../components';
import { getColumns, formItems } from './config';
import { mapActions, mapMutations, mapState } from 'vuex';
import sysList from '../../../store/module/sysList';
import util from '@/assets/js/util';
import ykRule from '../../../assets/js/ykRule';
import getPermissionMixin from '@/mixins/getPermissionMixin';
import authType from '../../../config/authType';

const addApplicationURL = '/v1/appBase/add';
const editApplicationURL = '/v1/appBase/edit';
export default {
  name: 'applicationManagePage',
  data() {
    return {
      authType,
      tableName: 'appList',
      sysList: sysList.sysList,
      show: true,
      message: '应用管理页面',
      // 当前的操作， 0是新建，1编辑
      currentOpeate: 0,
      system: '',
      formItems,
      filter: {
        pageSize: 10,
        appStatus: -1,
        appName: '',
        pageIndex: 1
      },
      columns: [],
      // 弹窗的属性
      // 指示是否显示新建应用弹窗
      createAppModelStatus: false,
      // 通讯录选择器的list
      addressList: [],
      appStatusList: [
        { label: '启用', value: 1 },
        { label: '禁用', value: 0 }
      ],
      modalTitle: '新建应用',
      // 弹窗异步加载指示器
      modalLoading: true,
      formValidate: {
        id: '',
        // 超市时长
        loginTimeoutSec: '',
        // 应用名称
        appName: '',
        // 排序
        appSortNum: '',
        // 选择的通讯录
        address: '91通讯录',
        // 微服务
        microServiceName: '',
        // 选择的状态
        appStatus: 1,
        remark: '',
        appLoginCallbackUrl: '',
        appUrl: ''
      },
      ruleValidate: {
        appName: [
          { required: true, message: '应用名称未填写', trigger: 'blur' }
        ],
        loginTimeoutSec: [
          { required: true, message: '超时时长未填写', trigger: 'blur' },
          { validator: ykRule.testPositiveNum, trigger: 'blur' }
        ],
        appSortNum: [
          {
            required: true,
            message: '排序权值未填写',
            trigger: 'blur'
          },
          { validator: ykRule.testPositiveNum, trigger: 'blur' }
        ],
        appLoginCallbackUrl: [{ required: false }],
        appUrl: [{ required: true, message: '应用地址未填写' }],
        address: [{ required: false }],
        microServiceName: [{ required: false }],
        appStatus: [{ required: false }],
        remark: [{ required: false }]
      }
    };
  },
  mixins: [getPermissionMixin],
  computed: {
    ...mapState('appManage', ['totalCount', 'dataSource', 'maxSortNum'])
  },
  components: { CustomButton },
  methods: {
    ...mapMutations('appManage', ['SAVE_STATE']),
    ...mapActions('appManage', [
      'getUserPermission',
      'getTableInfo',
      'deleteApp',
      'getMaxSortNum'
    ]),
    callBack(res) {
      const arr =
        res.pageComponentMap == null
          ? []
          : util.getFirstDataByObj(res.tableDataColMap) || [];
      const noShowArr = arr.map(item => item.colName);
      this.columns = getColumns(
        {
          deleteAppBtnClick: this.deleteAppBtnClick,
          editAppBtnClick: this.editAppBtnClick
        },
        noShowArr
      );
    },
    changeAlertMenu(row) {
      console.log(row);
      if (this.currentOpeate == 1) {
        // 编辑
        this.modalTitle = '编辑应用';
        this.formValidate.appName = row.appName.toString();
        this.formValidate.loginTimeoutSec = row.loginTimeoutSec.toString();
        this.formValidate.appSortNum = row.appSortNum.toString();
        // TODO: 缺通讯录选项
        this.formValidate.appStatus = row.appStatus;
        this.formValidate.remark = row.remark.toString();
        this.formValidate.id = row.id;
        this.formValidate.microServiceName = row.microServiceName.toString();
        this.formValidate.appLoginCallbackUrl = row.appLoginCallbackUrl;
        this.formValidate.appUrl = row.appUrl;
      } else if (this.currentOpeate == 0) {
        this.$ajax.get('/v1/appBase/nextSortNum/').then(res => {
          const { data, code } = res.data;
          // 新建
          this.modalTitle = '新建应用';
          this.formValidate.appName = '';
          this.formValidate.loginTimeoutSec = '';
          this.formValidate.appSortNum = data.toString();
          // TODO: 缺通讯录选项
          this.formValidate.microServiceName = '';
          this.formValidate.appStatus = 1;
          this.formValidate.remark = '';
          this.formValidate.id = '';
          this.formValidate.appLoginCallbackUrl = '';
          this.formValidate.appUrl = '';
        });
      }
    },
    pageSizeChange(size) {
      this.filter.pageSize = size;
      this.searchTableInfo();
    },
    showCreateAppli() {
      this.createAppModelStatus = true;
      this.currentOpeate = 0;
      this.changeAlertMenu({});
    },
    searchTableInfo() {
      this.filter.pageIndex = 1;
      this.getTableInfo({ filter: this.filter });
    },
    // 翻页
    changePage(num) {
      this.filter.pageIndex = num;
      this.getTableInfo({ filter: this.filter });
    },
    expertFileBtnClick() {
      util.fileDownload(
        this.$ajax,
        '/v1/appBase/export',
        this.filter,
        '应用管理'
      );
    },
    resetTableInfo() {
      this.filter = {
        appName: '',
        pageIndex: 1,
        pageSize: 10,
        appStatus: -1
      };
      this.getTableInfo({ filter: this.filter });
    },
    popCreateMoal() {
      this.createAppModelStatus = false;
      console.log(this.formValidate.appStatus);
    },
    editAppBtnClick(row) {
      this.createAppModelStatus = true;
      this.currentOpeate = 1;
      this.changeAlertMenu(row);
    },
    deleteAppBtnClick(row) {
      const self = this;
      this.$Modal.confirm({
        title: '提示',
        content: '是否删除该应用？',
        loading: true,
        cancelText: '取消',
        onOk: function() {
          self.deleteApp({
            row,
            func: (result, data) => {
              if (result != 'error') {
                self.$Modal.remove();
                self.searchTableInfo();
              } else {
                self.$Message.error(data.msg);
              }
            }
          });
        }
      });
    },
    handleSubmit(name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          const parms = this.formValidate;
          if (
            this.currentOpeate == 1 &&
            this.formValidate.appName == '权限系统' &&
            this.formValidate.appStatus == 0
          ) {
            this.$Message.error('权限系统不能禁用');
            return;
          }
          this.$ajax
            .post(
              this.currentOpeate == 0 ? addApplicationURL : editApplicationURL,
              parms
            )
            .then(res => {
              const { data } = res;
              if (data.code == 200) {
                this.$Message.success(
                  this.currentOpeate == 0 ? '添加成功' : '修改成功'
                );
                this.createAppModelStatus = false;
                this.searchTableInfo();
              } else {
                this.$Message.error(data.msg);
              }
            });
        } else {
          this.$Message.error('所填信息异常');
        }
      });
    }
  },
  mounted() {
    this.searchTableInfo();
  }
};
</script>
<style scoped>
.container {
  position: relative;
  padding: 0 20px;
}
.header {
  font-size: 32px;
}
.headerRight {
  float: right;
}
.leftButton {
  display: inline-block;
  padding-bottom: 20px;
}
.leftButton button:nth-child(2) {
  margin-left: 15px;
}
.rightButton {
  float: right;
  padding: 30px 200px 30px 200px;
}
.rightButton button {
  margin-left: 30px;
}
.createModalClass /deep/ .ivu-modal-footer {
  padding: 0 !important;
}
</style>
